import { apiRequest } from "../../services/api";
import { IBranchResponse } from "../type/branch.types";

export const getBranchList = async () => {
  const response = await apiRequest<IBranchResponse>("GET", "/branches");
  return response.data;
};
